/**
 * Utility function to scrollTo dom element
 * elm: id of dom element
 * time: milliseconde time animation
 */
export const useScrollTo = (elm: string, time: number): void => {
  const currentPos = window.pageYOffset
  let start = null as null | number

  if (document.getElementById(elm)) {
    const pos = document.getElementById(elm)?.offsetTop as number

    window.requestAnimationFrame(function step(currentTime) {
      start = !start ? currentTime : start

      const progress = currentTime - start

      if (currentPos < pos) {
        window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos)
      } else {
        window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time)
      }

      if (progress < time) {
        window.requestAnimationFrame(step)
      } else {
        window.scrollTo(0, pos)
      }
    })
  }
}
